import { toValue } from 'vue';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import { useCommonProductGetters } from '~/composables/useCommonProductGetters';
import { useProduct } from '~/modules/product/composables/useProduct';
import { useDeviceType } from './utils/useDeviceType';
import { useBrand } from './useBrand';
import { useUrlLocationOperations } from './useUrlLocationOperations';

export default function useSponsoredItems() {
  const { killswitches } = useKillswitches();
  const { isMobile } = useDeviceType();
  const { isDesktop } = useDeviceType();
  const { productData: product } = useProduct();
  const { isMcom } = useBrand();
  const {
    sponsoredItemsEnabled: isMonetizationEnabled,
    enableImpressionTagsForSMProducts,
    enableClickTagsForSMProducts,
    priceSimplificationEnabled,
    carouselOpenInNewTabEnabled,
    isBadgeSaleRed,
  } = killswitches;
  const { showSponsoredItemTop, shoppableRedesignOptimization } = useFeatureEligibility();
  const { taxonomy } = useCommonProductGetters();
  const { getSearchParamsData } = useUrlLocationOperations();
  const defaultCategoryId = toValue(taxonomy)?.defaultCategoryId;

  const siteMonConfig = {
    clientId: 'product',
    device: !isMobile.value ? 'desktop' : 'mobile',
    customStyleClass: shoppableRedesignOptimization
      ? 'small-margin-bottom-m large-margin-bottom-xl'
      : 'small-margin-bottom-xl large-margin-bottom-xxl',
    isSimplificationOn: priceSimplificationEnabled,
    deviceType: !isDesktop.value ? 'MOBILE' : 'DESKTOP',
    debug: getSearchParamsData()?.get('debugLog') === '1' || false,
    sponsoredItemsConfig: {
      categoryId: defaultCategoryId || '',
      product,
      pageType: 'product',
      showSponsoredItemTop,
    },
  };
  return {
    siteMonConfig,
    isMonetizationEnabled,
    enableImpressionTagsForSMProducts,
    enableClickTagsForSMProducts,
    isMcom,
    carouselOpenInNewTabEnabled,
    isBadgeSaleRed,
  };
}
